import React, { Component } from 'react';

import Landing from './landing';
import QuizResults from './QuizResults';
import Quiz from './Quiz';
import PersonalInfo from './PersonalInfo';
import AddressInfo from './AddressInfo';
import Error from './Error';
import PDF from './PDF'

import Card from '@material-ui/core/Card';
import { Container } from '@material-ui/core';
import { log } from 'util';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide'
import Grid from '@material-ui/core/Grid'
import { Progress } from 'react-sweet-progress';
import IdleTimer from 'react-idle-timer'

import { createMuiTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles';
import "react-sweet-progress/lib/style.css";


// This holds the page content for the assessments
// In the future, this could be what we embed in other websites




const org_guid = new URLSearchParams(window.location.search).get('org')
const assmnt_guid = new URLSearchParams(window.location.search).get('assmt')

let theme = null

class QuizContainer extends Component {
    constructor(props){
        super(props);
        this.state = {
          TCAccepted: false,
          ShowQuiz: false,
          ShowPersonalInfo: false,
          ShowAddress: false,
          Questions: [],
          Username: '',
          AuthToken: '',
          ParticipantGuid: '',
          ResponseGuid: '',
          RequirePersonInfo: true,
          RequireAddress: true,
          ResultsViewInstance: '',
          ShowResults: false,
          TCsDirection:'left',
          QuizsDirection:'left',
          PersonalDirection:'left',
          AddressDirection:'left',
          StartFromBeginning: true, 
          ResultsLoaded: false,
          QuestionsAnswered: 0,
          QuestionTotal: 1,
          UnitOfMeasure:'IMPERIAL',
          LoadingError: false,
          ErrorViewInstance: [],
          isTimedOut: false,
          timeout:1000*5*60,
          skipAddress: false,
          userEmail: "",
          CurrentIndex: 0
        }
        theme = createMuiTheme({
            palette: {
                primary: {
                    main: this.props.clientColor
                },
                secondary: {
                  main: this.props.clientColorSecondary
              }
            }
        })

        this.timer = null;
        this.handleOnAction = this.handleOnAction.bind(this)
        this.handleOnActive = this.handleOnActive.bind(this)
        this.handleOnIdle = this.handleOnIdle.bind(this)
        
    }

    componentDidMount(){
        this.setState({
            timeout: this.props.timeout
        })
        //this.setClientColor(this.props.clientColor)
    }
    // ********************
    //These are the timeout functions: 

    redirectToLanding(){
        this.setState({
            TCAccepted: false,
            ShowQuiz: false,
            ShowPersonalInfo: false,
            ShowAddress: false,
            ShowResults: false,
            QuestionsAnswered: 0,
            userEmail: "",
            CurrentIndex: 0
        })
    }

    handleOnAction(e) {
        this.setState({
            isTimedOut: false
        })
    }

    handleOnActive(e) {
        this.setState({
            isTimedOut: false
        })
    }

    handleOnIdle(e) {
        const isTimedOut = this.state.isTimedOut
        if(isTimedOut){
            this.redirectToLanding()
        } else {
            this.idleTimer.reset();
            this.setState({
                isTimedOut: true
            })
        }
        
    }

    //************************* */

    acceptTCs() {
        console.log("acceptTCs")
        //do the anon login, start assessment, get questions, then set TCAccepted to true?  I guess?  
        
        fetch('../../WsWebServicePlatform/LoginAnonymous',
            {method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',  
                }
            ,
            body: JSON.stringify({
                "ParamData":{
                    "GroupGuid":org_guid
                }
            })})
            .then(response=>response.json())
            .then(response=>{
                
                if(response.Success){
                    //startAssessment
                    let vars = response.Info[0]
                    fetch('../../WsWebServicePlatform/Participant/Setting/Set/' + vars.AuthToken + '/' + vars.ParticipantGuid + '/ASSMT%20PRODUCT%20GUID/' + assmnt_guid + '/',{
                        method:'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: {}
                    }
                    )
                    .then(response=>response.json())
                    .then(response=>{
                        console.log("Post setting set: ", response)
                        if(true){
                            fetch('../../WsWebServiceHra/StartAssessment/' + vars.AuthToken + '/' + assmnt_guid + '/',
                                {
                                method:'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: {

                                }
                            })
                        .then(response=>response.json())
                        .then(response=>{
                            if(response.Success){
                                this.setState({
                                    Username: vars.UserName,
                                    AuthToken: vars.AuthToken,
                                    ParticipantGuid: vars.ParticipantGuid,
                                    ResponseGuid: response.Info[0].AssmtGuid
                                }, () => {

                                    fetch('../../WsWebServiceWellSuite/GetViewInstance/' + this.state.AuthToken + '/8C292A8F-C14E-470B-A164-015F1CB2E2DD/',
                                        {
                                            method:'GET',
                                            headers:{
                                                'Accept': 'application/json'
                                            }
                                        })
                                    .then(response=>response.json())
                                    .then(response=>{
                                        this.setState({
                                            Questions: response.Info[0].ViewInstanceData[0].SurveyPage,
                                            StartFromBeginning: true,
                                            UnitOfMeasure: response.Info[0].ViewInstanceData[1].SessionVariableValues["UNIT OF MEASURE"]
                                        }, () =>{
                                            this.setState({
                                            TCAccepted: true,
                                            
                                            TCsDirection: 'right'

                                            }, ()=>{
                                                this.checkForAddress()
                                                setTimeout(() => {
                                                    this.setState({
                                                        //ShowResults: true
                                                        ShowQuiz: true
                                                        //ShowPersonalInfo: true
                                                        //ShowAddress: true
                                                    })
                                                }, 300)
                                            })
                                        })
                                    })
                                })
                            }
                            })
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
                    
                        
                        //this.updateValues(vars)
                    
                }
                else {
                    this.setState({
                        LoadingError: true
                    })
                    if(response.Status[0].ViewInstanceData){
                        this.setState({ErrorViewInstance: response.Status[0].ViewInstanceData[0].ErrorViewInstance})
                    } else {
                         var errorJSON = [{
                            "ComponentClass": "TEXTAREA",
                            "ComponentFamily": "VARIANT",
                            "ComponentType": "HEADER",
                            "ComponentContent": {
                              "Title": "Error",
                              "GradeLabel": ""
                            }
                          },
                          {
                            "ComponentClass": "TEXTAREA",
                            "ComponentFamily": "VARIANT",
                            "ComponentType": "SUBHEADER",
                            "ComponentContent": {
                              "Content": response.Status[0].ErrorMessage,
                              "ContentType": ""
                            }
                          }]
                         this.setState({
                            ErrorViewInstance: errorJSON
                         })
                    }
                }
                console.log("response: ", response)
            })
        
        //this.setState(() => {
        //    console.log(this.state)
        //    return { TCAccepted:true }
        //})
    }

    setClientColor(clientColor){
        theme = createMuiTheme({
        palette: {
            primary: {
                main: clientColor
            }
        }
    })}

    updateValues(vars){
        this.setState({
            Username: vars.UserName,
            AuthToken: vars.AuthToken,
            ParticipantGuid: vars.ParticipantGuid
        })
    }

    startAssessment(assmtProps){
        console.log("assmtProps", assmtProps)
    }

    backToQuiz = () => {
        this.setState({
            ShowPersonalInfo: false,
            StartFromBeginning: false
            }, ()=>{
                setTimeout(() => {
                    this.setState({
                        //ShowQuiz: true
                        ShowQuiz: true
                        //ShowPersonalInfo: true
                        //ShowAddress: true
                    })
                }, 300)
            })
    }

    showPersonalInfoCard = () => {
        this.setState({
            QuizsDirection: 'right',
            ShowAddress: false,
            ShowQuiz: false
        })
        setTimeout(() => {
            this.setState({
                ShowPersonalInfo: true
            })
        }, 300)
    }
 
    showAddressInfoCard = () => {
        this.setState({
            PersonalDirection: 'right',
            ShowPersonalInfo: false,
            ShowQuiz: false
        })
        setTimeout(() => {
            this.setState({
                ShowAddress: true
            })
        }, 300)
    }

    showResultsCard = () => {
        if(!this.state.ResultsLoaded){
            setTimeout(() => {
                this.showResultsCard()
            }, 200)
        } else {
            if(this.state.skipAddress){
                this.setState({
                    PersonalDirection: 'right',
                    ShowPersonalInfo: false,
                    ShowQuiz: false,
                    ShowAddress: false
                })
            }
            else {
                this.setState({
                AddressDirection: 'right',
                ShowPersonalInfo: false,
                ShowQuiz: false,
                ShowAddress: false
            })
            }
            setTimeout(() => {
                this.setState({
                    ShowResults: true
                })
            }, 300)
        }
        
    }

    getResultsViewInstance = () => {
        fetch('../../WsWebServiceWellSuite/GetViewInstance/' + this.state.AuthToken + '/2c29a5b8-fe78-446c-8979-a87733232d66/', 
        {
            method:'GET',
            headers:{
                'Accept': 'application/json'
            }
        })
        .then(response=>response.json())
        .then(response=>{
            console.log(response)
            if(response.Success){
                this.setState({
                    ResultsLoaded: true,
                    ResultsViewInstance: response.Info[0].ViewInstanceData[0].ReportViewInstance.ReportPage[0].ReportFrame
                })
            }
        })
        .then(response=>{
            console.log("State is set")
            console.log(this.state)
        })
    }

    setCurrentIndex = (index) => {
      this.setState({
        CurrentIndex: index
      })
    }

    updateQuestionsAnswered = (num, currentIndex) => {
        this.setState({
            QuestionsAnswered: num
        })
    }

    updateQuestionTotal = (num) => {
        this.setState({
            QuestionTotal: num
        })
    }

    checkForAddress() {
        var values = this.props.NameFrame;
        if(values.AddressCityVisible == "0" && values.AddressStateVisible == "0" && values.AddressStreetVisible == "0" && values.ZipVisible == "0"){
            this.setState({
                skipAddress: true
            })
        }
    }

    updateUserEmail(email) {
        this.setState({
            userEmail: email
        })
    }


    render(){
        let progressBar 
        let status='active'

        if(!this.state.TCAccepted || this.state.ShowResults){
            progressBar = <span></span>
        } else {
            if(this.state.QuestionsAnswered == this.state.QuestionTotal){
                status = 'success'
                
            } else {
                status = 'active'

            }
                progressBar = <Grid item xs={12} style={{margin:'-10px 0 10px 0'}}>
                                <Progress theme={{
                                            active: {
                                              color: this.props.clientColor
                                            },
                                            default: {
                                              color: this.props.clientColor
                                            }
                                          }} 
                                    status={status} percent={Math.floor((this.state.CurrentIndex)/this.state.Questions.SurveyData[0].QuestionSetQuestionSet.length*100)} />
                              </Grid>
        }
        if(!this.state.LoadingError){
            return(
            <ThemeProvider theme={theme}>
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    element={document}
                    onActive={this.handleOnActive}
                    onIdle={this.handleOnIdle}
                    onAction={this.handleOnAction}
                    debounce={250}
                    timeout={this.props.timeout} />     
                <Container fixed>
                    <h2 style={{textAlign:'center'}}></h2>
                    {progressBar}
                    <Slide in={!this.state.TCAccepted} direction={this.state.TCsDirection} mountOnEnter unmountOnExit timeout={300}>
                        <Box>
                            <Landing 
                            accept={this.acceptTCs.bind(this)} 
                            terms={this.props}/>
                        </Box>    
                    </Slide> 
                    <Slide in={this.state.TCAccepted && this.state.ShowQuiz} direction={this.state.QuizsDirection} mountOnEnter unmountOnExit timeout={300}>
                    <Quiz 
                            questions={this.state.Questions} 
                            authtoken={this.state.AuthToken}
                            responseguid={this.state.ResponseGuid}
                            startfromBeginning={this.state.StartFromBeginning}
                            uom={this.state.UnitOfMeasure}
                            validationMessages={this.props.ValidationMessages}
                            buttonLabel={this.props.NameFrame.ButtonLabel} 
                            questionPrompts={this.props.QuestionPrompts}
                            showPersonalInfoCard={this.showPersonalInfoCard.bind(this)}
                            getResultsViewInstance={this.getResultsViewInstance.bind(this)}
                            updateQuestionsAnswered={this.updateQuestionsAnswered.bind(this)}
                            updateQuestionTotal={this.updateQuestionTotal.bind(this)}
                            setCurrentIndex={this.setCurrentIndex.bind(this)}/>
                    
                    </Slide>
                    <Slide in={this.state.TCAccepted && this.state.ShowPersonalInfo}  direction={this.state.PersonalDirection} mountOnEnter unmountOnExit timeout={300}>
                        <Box>
                            <PersonalInfo 
                            viewInstance={this.props.NameFrame} 
                            authtoken={this.state.AuthToken} 
                            username={this.state.Username}
                            participantguid={this.state.ParticipantGuid} 
                            groupguid={org_guid}
                            showAddressInfoCard={this.showAddressInfoCard.bind(this)}
                            showresults={this.showResultsCard.bind(this)}
                            showQuiz={this.backToQuiz.bind(this)}
                            updateUserEmail={this.updateUserEmail.bind(this)}
                            skipAddress={this.state.skipAddress}/>
                        </Box>

                    </Slide>
                    <Slide in={this.state.TCAccepted && this.state.ShowAddress && !this.state.skipAddress} direction={this.state.AddressDirection} mountOnEnter unmountOnExit timeout={300}>
                        <Box>
                            <AddressInfo
                            viewInstance={this.props.AddressFrame} 
                            authtoken={this.state.AuthToken} 
                            username={this.state.Username}
                            participantguid={this.state.ParticipantGuid} 
                            groupguid={org_guid}
                            requirements={this.props.NameFrame}
                            countryList={this.props.countryList}
                            languageISO2={this.props.languageISO2}
                            showresults={this.showResultsCard.bind(this)}/>
                        </Box>
                    </Slide>
                    <Slide in={this.state.ShowResults} direction='left' mountOnEnter unmountOnExit timeout={300}>
                        <Box>
                            <QuizResults 
                            results={this.state.ResultsViewInstance} 
                            userEmail={this.state.userEmail} 
                            clientLogo = {this.props.ClientLogo} 
                            name={this.props.HeaderFrame.Name}
                            downloadPopup={this.props.DownloadPopup}
                            authtoken={this.state.AuthToken}
                            groupguid={org_guid}
                            />
                        </Box>
                    </Slide>
                </Container>
            </ThemeProvider>
        )
        } else {
            return <Error error={this.state.ErrorViewInstance} />
        }
        
    }
    
}
//<QuizResults results={NewPRViewInstance TestResultsViewInstance this.state.ResultsViewInstance} userEmail={this.state.userEmail}/>
// <QuizResults results={TestResultsViewInstance} userEmail={this.state.userEmail} clientLogo = {this.props.ClientLogo} name={this.props.HeaderFrame.Name} groupguid={'16fef634-1d70-4962-b452-1f13f3a561a7'} authtoken={'B043AE45-3828-4407-8F0B-330B768E5A5E'}/>
                        
//<Slide >
//                    {content}
//                </Slide> 
export default QuizContainer;